/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Coinvestments_Dataroom_Uploaderrors3Inputs */

const en_coinvestments_dataroom_uploaderrors3 = /** @type {(inputs: Coinvestments_Dataroom_Uploaderrors3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} files failed to upload`)
};

/**
* | output |
* | --- |
* | "{count} files failed to upload" |
*
* @param {Coinvestments_Dataroom_Uploaderrors3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_uploaderrors3 = /** @type {((inputs: Coinvestments_Dataroom_Uploaderrors3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Uploaderrors3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_uploaderrors3(inputs)
});
export { coinvestments_dataroom_uploaderrors3 as "coInvestments_dataRoom_uploadErrors" }